import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import makeStyles from '@material-ui/styles/makeStyles';
import Person from '@material-ui/icons/Person';
import { Participant } from 'twilio-video';

const useStyles = makeStyles({
  blue: {
    color: 'white',
    backgroundColor: '#2f43f2',
  },
});

export function getInitials(name: string) {
  return name
    .split(' ')
    .map(text => text[0])
    .join('')
    .toUpperCase();
}

export default function ParticipantAvatar({ participant }: { participant: Participant }) {
  const classes = useStyles();
  const { identity } = participant!;
  const photoURL = null;
  return photoURL ? (
    <Avatar src={photoURL} />
  ) : (
    <Avatar className={classes.blue}>{identity ? getInitials(identity) : <Person />}</Avatar>
  );
}
